<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import Couriers from './Couriers';

export default {
  name: 'App',
  components: {
    Couriers,
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue